import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const HERO_IMAGES = {
  about:     'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1400&q=80',
  services:  'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=1400&q=80',
  portfolio: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=1400&q=80',
  team:      'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=1400&q=80',
  products:  'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=1400&q=80',
  blog:      'https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=1400&q=80',
  careers:   'https://images.unsplash.com/photo-1531482615713-2afd69097998?w=1400&q=80',
  contact:   'https://images.unsplash.com/photo-1423666639041-f56000c27a9a?w=1400&q=80',
};

export default function ParallaxHero({ page, eyebrow, title, subtitle, cta, ctaLabel = 'Get Free Quote →', ctaTo = '/contact' }) {
  const imgRef = useRef(null);

  useEffect(() => {
    const el = imgRef.current;
    if (!el) return;
    const onScroll = () => {
      const rect = el.parentElement.getBoundingClientRect();
      const offset = rect.top * 0.38;
      el.style.transform = `translateY(${offset}px)`;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <section style={{ position:'relative', padding:'90px 0 78px', overflow:'hidden', minHeight:340, display:'flex', alignItems:'center' }}>
      {/* Parallax background image */}
      <div ref={imgRef} style={{
        position:'absolute', inset:'-30% 0', zIndex:0,
        backgroundImage:`url('${HERO_IMAGES[page] || HERO_IMAGES.about}')`,
        backgroundSize:'cover', backgroundPosition:'center',
        willChange:'transform'
      }}/>
      {/* Dark gradient overlay */}
      <div style={{ position:'absolute', inset:0, zIndex:1, background:'linear-gradient(135deg,rgba(18,9,30,.80) 0%,rgba(123,82,171,.70) 55%,rgba(75,184,232,.60) 100%)' }}/>
      {/* Dot grid */}
      <div style={{ position:'absolute', inset:0, zIndex:2, backgroundImage:'radial-gradient(circle,rgba(255,255,255,.06) 1px,transparent 1px)', backgroundSize:'38px 38px' }}/>
      {/* Content */}
      <div className="container" style={{ position:'relative', zIndex:3, textAlign:'center' }}>
        {eyebrow && (
          <div className="eyebrow" style={{ justifyContent:'center', color:'rgba(255,255,255,.82)' }}>{eyebrow}</div>
        )}
        <h1 style={{ fontFamily:"'Outfit',sans-serif", fontSize:'clamp(2.2rem,4vw,3.4rem)', fontWeight:900, color:'#fff', letterSpacing:'-.04em', lineHeight:1.1, marginBottom:14 }}>
          {title}
        </h1>
        {subtitle && (
          <p style={{ color:'rgba(255,255,255,.76)', fontSize:'1.05rem', maxWidth:560, margin:'0 auto 28px' }}>{subtitle}</p>
        )}
        {cta !== false && (
          <Link to={ctaTo} className="btn-white">{ctaLabel}</Link>
        )}
      </div>
    </section>
  );
}
